const GroupNames = {
  Mortgage: 'Mortgage',
  OLB: 'OLB',
};

export { GroupNames };
